import { createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 pt-5\"><h3 class=\"card-title align-items-start flex-column\"><span class=\"card-label fw-bolder fs-3 mb-1\">Latest Products</span><span class=\"text-muted mt-1 fw-bold fs-7\">More than 400 new products</span></h3><div class=\"card-toolbar\"><ul class=\"nav\"><li class=\"nav-item\"><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 active\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_5_tab_1\">Month</a></li><li class=\"nav-item\"><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_5_tab_2\">Week</a></li><li class=\"nav-item\"><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_5_tab_3\">Day</a></li></ul></div></div>", 1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade active show",
  id: "kt_table_widget_5_tab_1"
}
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-110px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-50px" })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/plurk.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Brad Simmons"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Movie Creator")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "React, HTML", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success" }, "Approved")
], -1)
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_14 = { class: "svg-icon svg-icon-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/telegram.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Popular Authors"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Most Successful")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "Python, MySQL", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, "In Progress")
], -1)
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_21 = { class: "svg-icon svg-icon-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/vimeo.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "New Users"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Awesome Users")
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "Laravel,Metronic", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, "Success")
], -1)
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_28 = { class: "svg-icon svg-icon-2" }
const _hoisted_29 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/bebo.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Active Customers"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Movie Creator")
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "AngularJS, C#", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-danger" }, "Rejected")
], -1)
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_35 = { class: "svg-icon svg-icon-2" }
const _hoisted_36 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/kickstarter.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Bestseller Theme"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Best Customers")
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "ReactJS, Ruby", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, "In Progress")
], -1)
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_42 = { class: "svg-icon svg-icon-2" }
const _hoisted_43 = {
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_2"
}
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_46 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-110px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-50px" })
  ])
], -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/plurk.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Brad Simmons"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Movie Creator")
], -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "React, HTML", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success" }, "Approved")
], -1)
const _hoisted_51 = { class: "text-end" }
const _hoisted_52 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_53 = { class: "svg-icon svg-icon-2" }
const _hoisted_54 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/telegram.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Popular Authors"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Most Successful")
], -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "Python, MySQL", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, "In Progress")
], -1)
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_60 = { class: "svg-icon svg-icon-2" }
const _hoisted_61 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/bebo.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Active Customers"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Movie Creator")
], -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "AngularJS, C#", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-danger" }, "Rejected")
], -1)
const _hoisted_65 = { class: "text-end" }
const _hoisted_66 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_67 = { class: "svg-icon svg-icon-2" }
const _hoisted_68 = {
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_3"
}
const _hoisted_69 = { class: "table-responsive" }
const _hoisted_70 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_71 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-110px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-50px" })
  ])
], -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/kickstarter.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Bestseller Theme"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Best Customers")
], -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "ReactJS, Ruby", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, "In Progress")
], -1)
const _hoisted_76 = { class: "text-end" }
const _hoisted_77 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_78 = { class: "svg-icon svg-icon-2" }
const _hoisted_79 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/bebo.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Active Customers"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Movie Creator")
], -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "AngularJS, C#", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-danger" }, "Rejected")
], -1)
const _hoisted_83 = { class: "text-end" }
const _hoisted_84 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_85 = { class: "svg-icon svg-icon-2" }
const _hoisted_86 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/vimeo.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "New Users"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Awesome Users")
], -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "Laravel,Metronic", -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, "Success")
], -1)
const _hoisted_90 = { class: "text-end" }
const _hoisted_91 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_92 = { class: "svg-icon svg-icon-2" }
const _hoisted_93 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("div", { class: "symbol symbol-45px me-2" }, [
    /*#__PURE__*/_createVNode("span", { class: "symbol-label" }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/svg/brand-logos/telegram.svg",
        class: "h-50 align-self-center",
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
  }, "Popular Authors"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block" }, "Most Successful")
], -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("td", { class: "text-end text-muted fw-bold" }, "Python, MySQL", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, "In Progress")
], -1)
const _hoisted_97 = { class: "text-end" }
const _hoisted_98 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_99 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["card", _ctx.widgetClasses]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("table", _hoisted_6, [
              _hoisted_7,
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _createVNode("td", _hoisted_12, [
                    _createVNode("a", _hoisted_13, [
                      _createVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _createVNode("td", _hoisted_19, [
                    _createVNode("a", _hoisted_20, [
                      _createVNode("span", _hoisted_21, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _createVNode("td", _hoisted_26, [
                    _createVNode("a", _hoisted_27, [
                      _createVNode("span", _hoisted_28, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _hoisted_32,
                  _createVNode("td", _hoisted_33, [
                    _createVNode("a", _hoisted_34, [
                      _createVNode("span", _hoisted_35, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_36,
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _createVNode("td", _hoisted_40, [
                    _createVNode("a", _hoisted_41, [
                      _createVNode("span", _hoisted_42, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _createVNode("table", _hoisted_45, [
              _hoisted_46,
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_47,
                  _hoisted_48,
                  _hoisted_49,
                  _hoisted_50,
                  _createVNode("td", _hoisted_51, [
                    _createVNode("a", _hoisted_52, [
                      _createVNode("span", _hoisted_53, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_54,
                  _hoisted_55,
                  _hoisted_56,
                  _hoisted_57,
                  _createVNode("td", _hoisted_58, [
                    _createVNode("a", _hoisted_59, [
                      _createVNode("span", _hoisted_60, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_61,
                  _hoisted_62,
                  _hoisted_63,
                  _hoisted_64,
                  _createVNode("td", _hoisted_65, [
                    _createVNode("a", _hoisted_66, [
                      _createVNode("span", _hoisted_67, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_68, [
          _createVNode("div", _hoisted_69, [
            _createVNode("table", _hoisted_70, [
              _hoisted_71,
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_72,
                  _hoisted_73,
                  _hoisted_74,
                  _hoisted_75,
                  _createVNode("td", _hoisted_76, [
                    _createVNode("a", _hoisted_77, [
                      _createVNode("span", _hoisted_78, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_79,
                  _hoisted_80,
                  _hoisted_81,
                  _hoisted_82,
                  _createVNode("td", _hoisted_83, [
                    _createVNode("a", _hoisted_84, [
                      _createVNode("span", _hoisted_85, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_86,
                  _hoisted_87,
                  _hoisted_88,
                  _hoisted_89,
                  _createVNode("td", _hoisted_90, [
                    _createVNode("a", _hoisted_91, [
                      _createVNode("span", _hoisted_92, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_93,
                  _hoisted_94,
                  _hoisted_95,
                  _hoisted_96,
                  _createVNode("td", _hoisted_97, [
                    _createVNode("a", _hoisted_98, [
                      _createVNode("span", _hoisted_99, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}